import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {
  ApiService,
  convertToFirePartitions,
} from "../../core/api/api.service";
import {ErrorMessage, LinkFirePartitionMessage} from "../../shared/constants/toastr.message";
import {
  FIRE_PARTITION_STATUSES, FIRE_PARTITION_TYPES, FirePartition,
  sortedValues,
} from "../../core/models/firepartition.type";

@Component({
    selector: 'bergh-link-unlink',
    templateUrl: './link-unlink.component.html',
    styleUrls: ['./link-unlink.component.scss'],
    standalone: false
})
export class LinkUnlinkComponent implements OnInit {
  @Input() data: any;
  @Input() docId: string;
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  loading: boolean = false;
  public fpStatus = sortedValues(FIRE_PARTITION_STATUSES);
  public fpTypes = sortedValues(FIRE_PARTITION_TYPES)
  id: string;
  public mapList = [];
  public extraWork = [
    {isextraWork: true, name: 'Ja'},
    {isextraWork: false, name: 'Nee'}
  ]
  public selectedExtraWork: boolean = null;
  public kind = '';
  public status = '';
  public map = '';
  public availableFP: FirePartition[] = [];
  public coupledList = [];
  public mapId;
  public filterObj = {}
  public toBeDelinkedFPs = []
  public toBeLinkedFPs = []
  public total = 0;
  public itemPerPage = 10;
  public currentPageNumber = 1;
  public selectedFP: FirePartition = null;
  popUpData = null;
  popUpIndex = null;
  popUpLink = null;
  popUpAllType = null;

  constructor(
    private _route: ActivatedRoute,
    private _toastr: ToastrService,
    private _api: ApiService,
  ) {
  }

  ngOnInit(): void {
    this.id = this._route.snapshot.paramMap.get('id');
    const MAP_DETAILS = localStorage.getItem('selectedMap');
    if (JSON.parse(MAP_DETAILS) !== null) {
      this.mapId = JSON.parse(MAP_DETAILS)._id;
    }
    this.getAllMapList();
    this.getAvailableFpForDocument();
    this.getLinkedFps()
  }

  public getAllMapList() {
    this.loading = true;
    this._api.request('getMapList', `${this.id}/map`).subscribe((res: any) => {
      this.mapList = res;
      localStorage.setItem('mapList', JSON.stringify(this.mapList));
    }, (error: any) => {
      console.error(error)
      this.loading = false;
    })
  }

  public getLinkedFps() {
    this.loading = true;
    this._api.request("getLinkedFPs", `${this.id}/document/${this.docId}/linked-firepartitions`).subscribe((result) => {
      this.coupledList = result
      this.loading = false;
    })
  }

  public getAvailableFpForDocument(resetPageNumber?) {
    this.loading = true;
    this.selectedExtraWork !== null ? this.filterObj["isExtraWork"] = this.selectedExtraWork : this.filterObj["isExtraWork"] = null
    this.map !== '' ? this.filterObj["mapId"] = this.map : this.filterObj["mapId"] = ""
    this.kind !== '' ? this.filterObj["typeId"] = this.kind : this.filterObj["typeId"] = ""
    this.status !== '' ? this.filterObj["statusId"] = this.status : this.filterObj["statusId"] = ""
    resetPageNumber ? this.currentPageNumber = 1 : this.currentPageNumber
    this.filterObj["pageNumber"] = this.currentPageNumber
    this.filterObj["itemPerPage"] = this.itemPerPage

    this._api.request('getAvailableFPs', this.filterObj, `${this.id}/document/${this.docId}/available-firepartitions`).subscribe((res: any) => {
      this.availableFP =  convertToFirePartitions(res.firepartitions);
      this.total = res.total
      this.loading = false;
    }, (error: any) => {
      console.error(error)
      this.loading = false;
    })
  }

  public linkFP(data, i) {

    this.availableFP.splice(i, 1);
    const totalPages = Math.ceil(this.total / this.itemPerPage)
    totalPages >= this.currentPageNumber && this.currentPageNumber > 1 && this.availableFP.length === 0 ? this.currentPageNumber-- : this.currentPageNumber
    this.toBeLinkedFPs.push(data._id)
    this.linkFPs();
  }

  public deLinkFP(data, i) {
    this.toBeDelinkedFPs.push(data._id)

    this.coupledList.splice(i, 1);
    this.delinkFPs();
  }

  public delinkFPs() {
    this.loading = true;
    const DELINK_FPS = {
      "firePartitionIds": this.toBeDelinkedFPs
    }
    this._api.request('unlinkFirePartition', DELINK_FPS, `${this.id}/document/${this.docId}/unlink-firepartitions`).subscribe((successResponse: any) => {
      if (successResponse) {
        this._toastr.success(LinkFirePartitionMessage.delink);
        this.getAvailableFpForDocument()
        this.toBeDelinkedFPs = []
        this.loading = false;
      } else {
        this._toastr.error(ErrorMessage.error + 'Ontkoppelen');
      }
    }, (error: any) => {
      console.error(error)
      this.loading = false;
    })
  }

  public linkFPs() {
    this.loading = true;
    const LINK_FPS = {
      "firePartitionIds": this.toBeLinkedFPs
    }
    this._api.request('linkFirePartition', LINK_FPS, `${this.id}/document/${this.docId}/link-firepartitions`).subscribe((successResponse: any) => {
      if (successResponse) {
        this._toastr.success(LinkFirePartitionMessage.add);
        this.getLinkedFps()
        this.getAvailableFpForDocument()
        this.toBeLinkedFPs = []
        this.loading = false;
      } else {
        this._toastr.error(ErrorMessage.error + 'Koppelen');
      }
    }, (error: any) => {
      console.error(error)
      this.loading = false;
    })
  }

  public linkDelinkAllFP(type) {
    if (type === 'Link') {
      this.availableFP.forEach((ele) => {

        this.toBeLinkedFPs.push(ele._id)
      });
      this.availableFP.splice(0, this.availableFP.length);
      const totalPages = Math.ceil(this.total / this.itemPerPage)
      totalPages >= this.currentPageNumber && this.currentPageNumber > 1 ? this.currentPageNumber-- : this.currentPageNumber = 1
      this.linkFPs()
    } else {
      this.coupledList.forEach((ele) => {

        this.toBeDelinkedFPs.push(ele._id)
      });
      this.coupledList.splice(0, this.coupledList.length);
      this.delinkFPs()
    }
  }

  async openInfoModel(id) {
    this.selectedFP = await this._api.getFirePartitionById(id)
    const {projectId} = this.availableFP.find((item) => item._id === id)
    this.selectedFP.projectId = projectId
  }

  public linkDelinkPopOver(data, i, isLink) {
    this.popUpData = data;
    this.popUpIndex = i;
    this.popUpLink = isLink;
  }

  public linkDelinkAllPopOver(type) {
    this.popUpAllType = type;
  }

}
